<div *ngIf="sellersArray" class="col-12 col-sm-6 mb-4">
  <label>Select a Seller</label>
  <app-select-box-search (valueChange)="displaySeller($event)" [placeholder]="'select bussines ..'" [list]="sellersArray"
                         [searchKey]="'name'">
  </app-select-box-search>
</div>
<div>
  <app-base-report *ngIf="statementReportData"
                   [hasDateRangeFilter]="true"
                   [hasCheckboxes]="false"
                   [reportName]="'Statement Report'"
                   [defaultColumns]="tableColumns"
                   [columnsDisplayNames]="displayTableColumns"
                   [data]="statementReportData"
                   [rowsLength]="totalNumberOfRecords"
                   (filterTrigger)="filter($event)"
                   (paginationChange)="paginate($event)"
                   (searchChange)="searchChance($event)"
                   [tableLoading]="loading"
                   [hasSort]="true"
                   (sortTrigger)="sortChange($event)"
                   [serviceInstance]="statmentReportService"></app-base-report>
</div>
